import actions from '../action/topic'
import CONSTANT from '../constant/topic'

const topicItemList = {
  page: {
    total: 0
  },
  list:[]
}
const topicBillboardList = {
  masterTitle: '',
  slaveTitle: '',
  bannerList: []
}

export default {
  actions,
  state: {
    topicItemList,
    topicBillboardList,
    isTopicNotExist: false
  },
  mutations: {
    [CONSTANT.TOPIC_GET_LIST_SUCCESS] (state, result) {
      return state.topicItemList = result
    },
    [CONSTANT.TOPIC_GET_LIST_ERROR] (state, e) {
      return state.topicItemList = { page: {total: 0 }, list: []}
    },
    [CONSTANT.TOPIC_GET_LIST_MORE_SUCCESS] (state, result) {
      return state.topicItemList = {...result, ...{list: [...state.topicItemList.list, ...result.list]}}
    },
    [CONSTANT.TOPIC_GET_LIST_MORE_ERROR] (state, e) {
      return state.topicItemList
    },
    [CONSTANT.TOPIC_BILLBOARDS_GET_LIST_SUCCESS] (state, result) {
      return state.topicBillboardList = result
    },
    [CONSTANT.TOPIC_BILLBOARDS_GET_LIST_ERROR] (state, e) {
      return state.topicBillboardList = {masterTitle: '', slaveTitle: '', bannerList: []}
    },
    [CONSTANT.TOPIC_ACTIVITY_OUT](state, e){
      return state.isTopicNotExist = true
    }
  }
}
